const NAVIGATION_V3_SELECTOR = "#mainNavigation[data-navigation-version='v3']";

export const isNavigationV3 = () =>
    Boolean(document.querySelector(NAVIGATION_V3_SELECTOR));

export const getNavigationBreakpoint = () => (isNavigationV3() ? 1024 : 768);

export const getNavigationClass = (mdClass, lgClass) =>
    isNavigationV3() ? lgClass : mdClass;

export const handleNavigationMediaQueryChange = (
    mobileCallback,
    desktopCallback,
) => {
    const breakpoint = getNavigationBreakpoint();
    const mediaQueryMobile = `(max-width: ${breakpoint - 1}px)`;
    const mediaQueryListMobile = window.matchMedia(mediaQueryMobile);

    const mediaQueryDesktop = `(min-width: ${breakpoint}px)`;
    const mediaQueryListDesktop = window.matchMedia(mediaQueryDesktop);

    const handleMobileChange = (event) => {
        if (event.matches && mobileCallback) {
            mobileCallback();
        }
    };

    const handleDesktopChange = (event) => {
        if (event.matches && desktopCallback) {
            desktopCallback();
        }
    };

    mediaQueryListMobile.addEventListener("change", handleMobileChange);
    mediaQueryListDesktop.addEventListener("change", handleDesktopChange);

    handleMobileChange(mediaQueryListMobile);
    handleDesktopChange(mediaQueryListDesktop);
};
